<template>
    <div class="reo-select"
        :style="styleOut"
        :class="[{ 'drop_down': isListShow, 'disabled': disabled },colorType]"
        :data-transaction-name="dataTransactionName">
        <div class="divSelect" ref="divSelect" :data-transaction-name="dataTransactionName">
            <div class="divSelectInput" @click="toggleDropDown" :data-transaction-name="dataTransactionName">
                <!-- 选中后的内容 -->
                <div class="selectInfos" :title="label" :class="{ 'no_select': label == 'Please select' }" > {{ label }} </div>
                <!-- 三角形图标 -->
                <i class="triangle icon-co_down" :class="{ 'reverse': !isListShow }"></i>
            </div>
        </div>
        <!-- 下拉框列表 -->
        <popper ref="popper" v-model="isListShow">
        </popper>
        <component :is="!isMobile? 'div': 'transition'" name="drop-down">
            <div class="select-list-container"
                v-show="isListShow"
                ref="dropDown"
                @click.prevent="()=> {isMobile ? toggleDropDown() : null}"
            >
                <div class="selectList" v-show="isListShow">
                    <div class='header' v-if="!isSingleSelector && isMobile">
                        <span class='btnConfirm' @click.stop='toggleDropDown'>OK</span>
                    </div>
                    <ul class="option_list" :style="styleList">
                        <tree-option
                            v-for="option of treeOptions"
                            :key="option.id"
                            :current-option="option"
                            :show-icon='showIcon'
                            :data-source="selectorOptions"
                            :selector-type="selectorType"
                            :prop-selection="selection"
                            :reachMaxSelect="reachMaxSelect"
                            :allOptionDisableOthers="allOptionDisableOthers"
                            :width-in="widthIn"
                            :height-in="heightIn"
                            :font-size-in="fontSizeIn"
                            :maxSelect="maxSelect"
                            @select="handleSelectionChange"
                        ></tree-option>
                    </ul>
                    <div class='footer' v-if="!isSingleSelector && !isMobile">
                        <button class='btnConfirm' @click.stop='toggleDropDown' :data-transaction-name="dataTransactionName">{{ $t('dialog.ok') }}</button>
                    </div>
                </div>
            </div>
        </component>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Popper from 'element-ui/lib/utils/vue-popper.js'; // 利用element的popper进行管理
import { ESelectorType, IReoSelectOption } from '@reolink-cloud/interface';
import TreeOption from './TreeOption.vue';
import { DIALOG_ADD, DIALOG_REDUCE } from '@/store/mutation-types';
import * as _ from '@reolink-web/utils';
Popper.render = ( h ) => h( null );

export default Vue.extend({
    name: 'ReoSelect',
    components: {
        Popper,
        TreeOption
    },
    props: {
        colorType: {
            type: String,
            default: 'light'
        },
        selectorType: {
            type: String as PropType<ESelectorType>,
            default: ESelectorType.SINGLE
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Please select'
        },
        widthOut: {
            type: [String, Number],
            default: 1.8
        },
        heightOut: {
            type: [String, Number],
            default: 0.4
        },
        fontSizeOut: {
            type: [String, Number],
            default: 0.16
        },
        triangleRight: {
            type: [String, Number],
            default: 0.4
        },
        selectMarginLeft: {
            type: [String, Number],
            default: 0.12
        },
        widthIn: {
            type: [String, Number],
            default: -1
        },
        heightIn: {
            type: [String, Number],
            default: 0.3
        },
        fontSizeIn: {
            type: [String, Number],
            default: 0.16
        },
        maxHeight: {
            type: [String, Number],
            default: 1.8
        },
        optionListMinWidth: Number,
        /** 平铺的选项 */
        options: {
            type: Array as PropType<IReoSelectOption[]>,
            default: (): IReoSelectOption[] => {

                return [];

            }
        },
        defaultSelected: {
            type: [String, Number, Array],
            default: 'all'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxSelect: {
            type: Number,
            default: -1
        },
        /** 全选按钮被勾选时，是否禁用其他选项 */
        allOptionDisableOthers: {
            type: Boolean,
            default: false
        },
        dataTransactionName: String
    },
    data () {

        /** 传进来的选项可能是computed构造的，没有监听 */
        const selectorOptions: IReoSelectOption[] = this.options.map(( option ) => {

            return {
                ..._.Object.deepClone( option ),
                selected: false
            };

        });
        return {

            ESelectorType,
            isListShow: false,

            selectorOptions,
            label: '',
        };

    },
    mounted () {

        let _this = this;

        const popperRef = this.$refs.popper as Vue & { popperElm: any; referenceElm: any; };

        popperRef.popperElm = _this.$refs['dropDown'];
        popperRef.referenceElm = _this.$el;

        // 点击元素以外的空间时元素消失;
        document.addEventListener( 'click', function ( e ) {

            const shouldShowList = _this.$refs.divSelect && (
                ( _this.$refs.divSelect as HTMLElement ).contains( e.target as HTMLElement ) ||
                ( _this.$refs.dropDown as HTMLElement ).contains( e.target as HTMLElement )
            );

            if ( !shouldShowList ) {

                _this.isListShow = false;

            }

        });

        this.handleDefaultSelected();
        this.checkSelected();

    },

    beforeDestroy () {

        if ( this.isMobile && this.isListShow ) {

            this.dialogDestroyed();

        }

    },

    computed: {
        isSingleSelector(): boolean {

            return this.selectorType === ESelectorType.SINGLE;

        },
        /** 选择器的样式（非选择列表） */
        styleOut (): Record<string, string> {

            return {
                '--select-height': Number( this.heightOut ) * 100 + 'px',
                '--select-width': this.widthOut === -1 ? '100%' : Number( this.widthOut ) * 100 + 'px',
                '--select-triangle-margin': Number( this.triangleRight ) * 100 + 'px',
                '--select-margin-left': Number( this.selectMarginLeft ) * 100 + 'px',
                '--select-font-size': Number( this.fontSizeOut ) * 100 + 'px'
            };

        },
        /** 选项列表的样式 */
        styleList (): Record<string, string>  {

            return {
                '--list-max-height': Number( this.maxHeight ) * 100 + 'px',
                '--list-min-width': this.optionListMinWidth ? Number( this.optionListMinWidth ) * 100 + 'px' : 'unset'
            };

        },
        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        treeOptions(): IReoSelectOption[] {

            if ( this.isSingleSelector ) {

                return this.selectorOptions;

            } else {

                return this.selectorOptions.filter( option => {

                    if ( !option.parentId ) { // 一级多选

                        return true;

                    } else { // 多级多选 all选项的id为-2，其他一级选项接口返回key的id为0

                        return [-2, 0].includes( option.parentId );

                    }

                });

            }

        },
        reachMaxSelect(): boolean {

            if ( this.maxSelect === -1 ) {

                return false;

            }

            const selectedNum = this.selectorOptions.filter( _option => _option.selected ).length;

            return selectedNum >= this.maxSelect;

        },
        selection(): Array<string | number> {

            if ( this.selectorOptions.every( option => option.selected ) && this.selectorOptions.some( item => item.value === 'all' )) {

                return ['all'];

            }

            return this.selectorOptions.filter( option => option.selected ).map( option => option.value );

        }
    },
    methods: {
        toggleDropDown () {

            this.isListShow = !this.isListShow;
            if ( this.isMobile ) {

                if ( this.isListShow && this.isMobile ) {

                    this.dialogMounted();

                } else {

                    this.dialogDestroyed();

                }

            }

        },

        handleDefaultSelected() {

            for ( const _option of this.selectorOptions ) {

                if ( Array.isArray( this.defaultSelected )) {

                    if ( this.defaultSelected.includes( 'all' )) {

                        for ( const _option of this.selectorOptions ) {

                            this.$set( _option, 'selected', true );

                        }
                        return;

                    } else {

                        this.$set( _option, 'selected', true );

                    }

                } else {

                    if ( _option.value === this.defaultSelected ) {

                        this.$set( _option, 'selected', true );

                    } else {

                        this.$set( _option, 'selected', false );

                    }

                }

            }

        },

        /** 没有选中时点击确认，会将all选上 */
        confirm () {

            if ( this.isSingleSelector ) {

                this.$emit( 'input', this.selection[0] );

            } else {

                if ( this.selection.length === 0 ) {

                    if ( this.selectorOptions.find( option => option.value === 'all' )) {

                        for ( let option of this.selectorOptions ) {

                            this.$set( option, 'selected', true );

                        }

                        this.checkSelected();
                        this.$emit( 'selectionChange', ['all'] );

                    } else {

                        this.checkSelected();
                        this.$emit( 'selectionChange', [] );

                    }

                } else {

                    this.$emit( 'selectionChange', this.selection );

                }

            }

        },

        handleSelectionChange ( selected: boolean, option: IReoSelectOption ) {

            if ( this.isSingleSelector ) {

                this.toggleDropDown();

                if ( !selected ) {

                    this.$set( option, 'selected', false );

                    this.checkSelected();
                    return;

                }

                for ( const _option of this.selectorOptions ) {

                    if ( _option.id === option.id ) {

                        this.$set( _option, 'selected', selected );

                    } else {

                        this.$set( _option, 'selected', false );

                    }

                }

            } else {

                this.$set( option, 'selected', selected );

                if ( option.value === 'all' ) {

                    for ( const _option of this.selectorOptions ) {

                        this.$set( _option, 'selected', selected );

                    }

                } else {

                    // 处理子选项
                    for ( let _option of this.selectorOptions ) {

                        if ( _option.parentId === option.id ) {

                            this.$set( _option, 'selected', selected );

                        }

                    }

                    // 处理父选项
                    if ( option.parentId ) {

                        const parentOption = this.selectorOptions.find(( __option ) => __option.id === option.parentId )!;
                        const childrenOptions = this.selectorOptions.filter(( __option ) => __option.parentId === option.parentId );
                        const shouldSelectAllChildren: boolean = childrenOptions.every( __option => __option.selected );
                        this.$set( parentOption, 'selected', shouldSelectAllChildren );

                    }

                    // 遍历选项，判断是否选中all
                    const shouldSelectAll: boolean = this.selectorOptions.filter( option => option.value !== 'all' ).every( _option => _option.selected );
                    const allOption = this.selectorOptions.find(( option ) => option.value === 'all' )!;
                    if ( allOption ) {

                        this.$set( allOption, 'selected', shouldSelectAll );

                    }

                }

            }

            this.checkSelected();

        },

        checkSelected() {

            let currentSelectedOption: IReoSelectOption | IReoSelectOption[] = [] ;

            for ( const option of this.selectorOptions ) {

                if ( option.selected ) {

                    if ( this.isSingleSelector ) {

                        currentSelectedOption = option;

                    } else {

                        ( currentSelectedOption as IReoSelectOption[] ).push( option );

                    }

                }

            }
            if ( currentSelectedOption ) {

                if ( !this.isSingleSelector ) {

                    let result: IReoSelectOption[] = [];

                    // 先把父节点选出来
                    result = ( currentSelectedOption as IReoSelectOption[] )
                        .filter( _option => !_option.parentId && _option.selected );

                    for ( let _option of currentSelectedOption as IReoSelectOption[] ) {

                        // 父选项和子选项不能同时存在
                        if ( !result.find( __option => __option.id === _option.parentId ) && !result.find( __option => __option.id === _option.id )) {

                            result.push( _option );

                        }

                    }
                    if ( result.some( _option => _option.value === 'all' )) {

                        for ( const option of this.selectorOptions ) {

                            if ( option.selected ) {

                                this.$set( option, 'selected', true );

                            }

                        }

                    }
                    const selectedLength = this.selection.length;
                    if ( this.reachMaxSelect && selectedLength > this.maxSelect ) {

                        for ( const option of this.selectorOptions ) {

                            if ( option.selected ) {

                                this.$set( option, 'selected', false );

                            }

                        }

                    }

                }

            }

        },
        dialogMounted (): void {

            this.$store.commit( DIALOG_ADD );

        },
        dialogDestroyed (): void {

            this.$store.commit( DIALOG_REDUCE );

        }

    },
    watch: {

        isMobile ( newVal: boolean, oldVal: boolean ) {

            if ( newVal === oldVal || !this.isListShow ) {

                return;

            }

            if ( oldVal ) {

                this.dialogDestroyed();

            }
            this.isListShow = false;

        },

        /** 监听selection的变化，更新label */
        selection( newVal: string[] ) {

            if ( newVal.length === 0 ) {

                this.label = this.placeholder;

            } else {

                if ( newVal.includes( 'all' )) {

                    this.label = this.selectorOptions.find( item => item.value === 'all' )!.label;

                }
                else {

                    this.label = newVal.map( value => {

                        for ( const item of this.selectorOptions ) {

                            if ( item.value === value ) {

                                return item.label;

                            }

                        }

                    }).join( '/' );

                }

            }

        },

        /** 监听isListShow的变化，更新dialog状态，多选时协助确认 */
        isListShow ( newVal ) {

            if ( newVal ) {
                /** empty */
            } else {

                this.confirm();

            }

        },

        options( newVal: IReoSelectOption[] ) {

            this.selectorOptions = newVal.map(( option ) => {

                return {
                    ...option,
                    selected: false
                };

            });
            this.handleDefaultSelected();
            this.checkSelected();

        },

        defaultSelected:{
            handler() {

                this.handleDefaultSelected();
                this.checkSelected();
                /**
                 * 这个事件只有selectProduct 组件才会用到
                 * 使用confirm会导致其他选择页面多次触发改动事件
                 */
                this.$emit( 'default', this.selection[0] );

            },
            immediate: true
        }
    }

});
</script>
<style scoped lang="less">
    .reo-select {
        height: var(--select-height);
        width: var(--select-width);
        line-height: var(--select-height);
        display: inline-block;
        color: @font_primary;
        font-weight: 500;
        cursor: pointer;
        border-radius: @border-radius-level-button;
        &.dark{
            border: 1px solid @bg_03;
            background-color: @bg_03;
        }
        &.light{
            border: 1px solid @font_tertiary;
        }
        @media @snapeak_pc{
            &:hover{
                border-color:@brand_light;
            }
        }
        @media @snapeak_mobile{
            &:active{
                border-color:@brand_light;
            }
        }
        &.disabled{
            color: @font_disable;
        }
        &.drop_down {
            border-color:@brand_light;
        }
        .divSelect {
            width: 100%;
            height: 100%;
            .divSelectInput {
                margin-left: var(--select-margin-left);
                display: flex;
                align-items:center;
                justify-content: space-between;
                .selectInfos {
                    font-size: var(--select-font-size);
                    line-height: 1.2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: 400;
                }
                .triangle {
                    font-size: 16px;
                    margin-right: var(--select-triangle-margin);
                    line-height: var(--select-height);
                    text-align: center;
                    transform: rotate(180deg);
                    transition: all 0.4s;
                    &.reverse {
                        transform: rotate(0deg);
                    }
                }
            }
        }
    }

    @media @snapeak_mobile{
        .select-list-container{
            top: 0 !important;
            left: 0 !important;
            position: fixed !important;
            width: 100%;
            z-index: 299;
            height: 130vh;
            overflow: hidden;
            background-color: rgba(#000,0.6);
        }
    }
    .selectList {
        padding: 6px 0;
        @media @snapeak_pc{
            box-shadow: 0px 5px 15px 3px rgba(0, 0, 0, 0.15);
            background-color: @select-list-background-color-pc;
            border: 1px solid @select-list-border-color;
            border-radius: @border-radius-level-button;
            margin-top: 8px;
        }
        @media @snapeak_mobile{
            background-color: @select-list-background-color-mobile;
            position: fixed;
            bottom: 0;
            z-index: 299;
            width: 100%;
            left:0;
            margin:0;
            padding: 14px 0 0;
            border-top-left-radius:12px;
            border-top-right-radius:12px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            /deep/ .multipleSelect{
                span.text{
                    font-size: .28rem;
                    font-family: @font_02;
                    margin-left: .24rem;
                }
            }
        }
        .header{
            line-height: 1.2;
            text-align: right;
            padding: 0 0.3rem 0.4rem;
            box-sizing: border-box;
        }
        .footer{
            overflow: hidden;
        }
        .btnConfirm{
            @media @snapeak_pc{
                margin: .1rem .16rem .06rem 0;
                padding: .05rem .16rem;
                border:none;
                height:.28rem;
                float:right;
                background:@brand_light;
                border:none;
                color:#fff;
                cursor: pointer;
            }
            @media @snapeak_mobile{
                color:@brand_light;
                font-size: 17px;
                font-weight: 500;
                line-height: 1.2;
            }
        }
        .option_list {
            width: 100%;
            max-height: var(--list-max-height);
            overflow-y :auto;
            overflow-y: overlay;
            overflow-x: hidden;
            scrollbar-width: auto;
            min-width: var(--list-min-width);
            @media @mobile{
                max-height: 80vh;
            }
            &::-webkit-scrollbar{
                width:4px;
            }
            &::-webkit-scrollbar-thumb{
                background-color: @font_fourth;
                border-radius: 3px;
            }
            // 隐藏所有箭头按钮
            &::-webkit-scrollbar-button{
                display: none;
            }
            /deep/ & > li:nth-last-child(1){
                .option_dropdown_item{
                    border-bottom: none;
                }
            }

        }
    }
    @media @snapeak_mobile{
        /** 下拉框出现动画 */
        .drop-down-enter {
            opacity: 0;
        }
        .drop-down-leave-to {
            opacity: 0;
        }
        .drop-down-enter-active {
            transition: all 0.4s ease;
        }
        .drop-down-leave-active {
            transition: all 0.4s ease;
        }
    }
</style>
